import gql from 'graphql-tag'

export default gql`
  mutation addPaymentMethod($paymentMethodId: String!, $newCustomerInfo: StripeNewCustomerInfoInput) {
    addPaymentMethod(paymentMethodId: $paymentMethodId, newCustomerInfo: $newCustomerInfo) {
      success
      message
    }
  }
`
